.paragraph:global(.ant-typography) {
  margin: 0;
}

.paragraph:global(.ant-typography) p {
  margin: 0;
}
